import event from '@drivesally/sally-fw/lib/event/event';

export default event('/event/app/launch');
